'use strict';

var Remarkable = require('remarkable');

var md = new Remarkable('full', {
	html: true,
	xhtmlOut: false,
	breaks: false,
	linkify: true
});

var renderMarkdown = function renderMarkdown(input) {
	return md.render(input);
};

module.exports = renderMarkdown;


//////////////////
// WEBPACK FOOTER
// ./~/lokum/lib/renderMarkdown.js
// module id = 355
// module chunks = 0